var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_15342)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.2322 0C15.2834 0 15.3346 0 15.3887 0C15.5142 1.55149 14.922 2.71075 14.2023 3.55026C13.4961 4.38396 12.5291 5.19255 10.9651 5.06986C10.8607 3.5406 11.4539 2.46731 12.1727 1.62974C12.8392 0.849163 14.0613 0.154569 15.2322 0Z",
    fill: "#1E1531"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9671 16.1482C19.9671 16.1636 19.9671 16.1772 19.9671 16.1917C19.5275 17.5229 18.9005 18.6638 18.1354 19.7226C17.4369 20.6838 16.581 21.9774 15.0527 21.9774C13.7321 21.9774 12.8549 21.1282 11.5015 21.105C10.0698 21.0818 9.28247 21.8151 7.97346 21.9996C7.82372 21.9996 7.67399 21.9996 7.52714 21.9996C6.56592 21.8605 5.79017 21.0992 5.22503 20.4133C3.55858 18.3865 2.27083 15.7685 2.03125 12.4182C2.03125 12.0898 2.03125 11.7623 2.03125 11.4338C2.13269 9.03608 3.29775 7.08658 4.84634 6.14178C5.66362 5.63943 6.78714 5.21147 8.03819 5.40274C8.57435 5.48583 9.1221 5.66938 9.60223 5.85099C10.0572 6.02585 10.6263 6.33595 11.1653 6.31953C11.5305 6.30891 11.8937 6.11859 12.2618 5.98431C13.3399 5.59499 14.3968 5.14867 15.7898 5.35831C17.464 5.61141 18.6522 6.35528 19.3865 7.50295C17.9702 8.40428 16.8506 9.76256 17.0418 12.0821C17.2119 14.189 18.4368 15.4217 19.9671 16.1482Z",
    fill: "#1E1531"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_15342"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.e1c974461d1dd02bc7196c72872e629f.svg";
export { ForwardRef as ReactComponent };